import axios, { HttpStatusCode } from "axios"
import { InvalidCredentialsError } from "../errors/authErrors";
import { MissingDataError } from "../errors/genericErrors";

export default class AuthApi {
  static login = async (body) => {
    try {
      const response = await axios.post("/api/staffMembers/login", body);
      return response.data;
    }
    catch (error) {
      console.error("Login error:", error.response?.data || error.message);
      switch(error.response?.status) {
        case HttpStatusCode.Forbidden:
          throw new InvalidCredentialsError();
        case HttpStatusCode.BadRequest:
          throw new MissingDataError();
        default:
          throw error;
      }
    }
  }

  static requestOtp = async (body) => {
    return await axios.post("/api/staffMembers/request-otp", body);
  }

  static verifyOtp = async (body) => {
    return await axios.post("/api/staffMembers/verify-otp", body);
  }

  static logout = async (body) => {
    try {
      await axios.get("/api/staffMembers/logout");
    }
    catch (error) {
      console.error("Logout error:", error.response?.data);
    }
  }
}